import { centsToUsdAmount } from '@/utils/money';
import { useLocale } from '@/hooks/useLocale';

interface BalanceFormatterProps {
  cents?: number | null;
  hidden?: boolean;
}

export function BalanceFormatter({ cents, hidden }: BalanceFormatterProps): JSX.Element {
  const { locale } = useLocale();
  if (hidden) return <span>•• ••• •••</span>;
  return <span>{centsToUsdAmount(cents ?? 0, locale)}</span>;
}
